import React from 'react'
import { UserProfilePage } from 'Features/userProfile/routes/UserProfile/UserProfile.styled'
import { ProfileSection } from 'Features/userProfile/components/ProfileSection/ProfileSection'

import { PreferencesSection } from 'Features/userProfile/components/PreferencesSection/PreferencesSection'
import { NotificationsSection } from 'Features/userProfile/components/NotificationsSection/NotificationsSection'

export const UserProfile = () => {
  return (
    <UserProfilePage id={'user-profile-page'}>
      <ProfileSection />
      <PreferencesSection />
      <NotificationsSection />
    </UserProfilePage>
  )
}
